module.exports = __webpack_public_path__ + "static/media/stage-background.0c78f4ab.svg";